import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO, { SITE_URL } from '@/components/SEO';
import { useProductsData } from '@/hooks/useTranslatedData';
import { useTranslation } from 'react-i18next';

const productsSchema = {
  '@type': 'ItemList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '功能性软糖与凝胶糖果',
      url: `${SITE_URL}/products`,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: '冻干即食滋补品',
      url: `${SITE_URL}/products`,
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: '中式草本能量棒/烘焙',
      url: `${SITE_URL}/products`,
    },
  ],
};

export default function Products() {
  const { t } = useTranslation('common');
  const data = useProductsData();
  const [activeTrack, setActiveTrack] = useState(0);
  const currentTrack = data.tracks[activeTrack];

  const getTrackColor = (index: number) => {
    switch (index) {
      case 0: return { active: 'bg-brand-mint text-white', dot: 'bg-brand-mint', light: 'bg-brand-mint-light' };
      case 1: return { active: 'bg-brand-coral text-white', dot: 'bg-brand-coral', light: 'bg-brand-coral-light' };
      case 2: return { active: 'bg-brand-green text-white', dot: 'bg-brand-green', light: 'bg-brand-green-light' };
      default: return { active: 'bg-brand-charcoal text-white', dot: 'bg-brand-charcoal', light: 'bg-brand-cream' };
    }
  };

  const productImages = [
    [
      'https://readdy.ai/api/search-image?query=Premium%20functional%20gummy%20supplements%20in%20modern%20minimalist%20packaging%20with%20herbal%20motifs%2C%20colorful%20translucent%20gummies%20on%20clean%20white%20surface%2C%20warm%20studio%20lighting%2C%20coral%20and%20mint%20color%20palette%2C%20high-end%20health%20food%20product%20photography%2C%20shallow%20depth%20of%20field&width=400&height=300&seq=70&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Elegant%20beauty%20wellness%20gummy%20supplements%20with%20pearl-like%20translucent%20appearance%2C%20rose%20petals%20and%20sea%20buckthorn%20berries%20nearby%2C%20clean%20white%20marble%20surface%2C%20soft%20pink%20and%20coral%20lighting%2C%20premium%20skincare%20food%20product%20photography&width=400&height=300&seq=71&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Calming%20sleep%20aid%20gummy%20supplements%20in%20elegant%20packaging%20with%20lavender%20botanical%20theme%2C%20soft%20purple%20and%20cream%20color%20palette%2C%20serene%20peaceful%20atmosphere%2C%20clean%20minimal%20product%20photography%2C%20diffused%20soft%20lighting&width=400&height=300&seq=72&orientation=landscape',
    ],
    [
      'https://readdy.ai/api/search-image?query=Premium%20freeze-dried%20bird%20nest%20and%20tremella%20soup%20in%20elegant%20modern%20cup%20packaging%2C%20golden%20translucent%20soup%20with%20silver%20ear%20mushroom%20pieces%2C%20clean%20white%20background%2C%20warm%20natural%20lighting%2C%20high-end%20health%20food%20product%20photography%2C%20soft%20shadows&width=400&height=300&seq=73&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Colorful%20freeze-dried%20fruit%20chips%20including%20fig%20peach%20mulberry%20arranged%20in%20modern%20minimalist%20packaging%2C%20vibrant%20natural%20colors%2C%20clean%20white%20background%2C%20premium%20snack%20brand%20product%20photography%2C%20soft%20natural%20lighting&width=400&height=300&seq=74&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Premium%20probiotic%20powder%20in%20modern%20small%20elegant%20jars%20with%20minimalist%20labels%2C%20soft%20pastel%20blue%20and%20white%20color%20palette%2C%20clean%20white%20background%2C%20health%20food%20brand%20product%20photography%2C%20professional%20studio%20lighting&width=400&height=300&seq=75&orientation=landscape',
    ],
    [
      'https://readdy.ai/api/search-image?query=Premium%20black%20sesame%20energy%20balls%20arranged%20on%20natural%20bamboo%20mat%2C%20modern%20minimalist%20packaging%20with%20Chinese%20ink%20aesthetic%2C%20deep%20black%20and%20gold%20tones%2C%20traditional%20Chinese%20health%20food%20product%20photography%2C%20clean%20background&width=400&height=300&seq=76&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20herbal%20pastry%20with%20red%20bean%20and%20poria%20cocos%2C%20modern%20minimalist%20food%20photography%2C%20warm%20earth%20tones%2C%20clean%20white%20ceramic%20plate%2C%20soft%20natural%20lighting%2C%20premium%20health%20snack%20product%20photography&width=400&height=300&seq=77&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Premium%20plant-based%20protein%20jerky%20strips%20in%20modern%20packaging%2C%20natural%20wood%20surface%20background%2C%20earthy%20brown%20tones%20with%20green%20accents%2C%20clean%20minimal%20product%20photography%2C%20health%20food%20brand%20editorial%20style&width=400&height=300&seq=78&orientation=landscape',
    ],
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="产品系列 | 膳兜兜 foodgogo"
        description="膳兜兜foodgogo三大产品系列：功能性软糖与凝胶糖果、冻干即食滋补品、中式草本能量棒/烘焙，将实验室科技融入轻养生美食。"
        keywords="膳兜兜,功能性软糖,冻干滋补,中式草本,能量棒,健康零食,轻养生食品"
        schema={productsSchema}
      />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-24 md:pt-32 pb-16 md:pb-20 overflow-hidden">
          {/* KV Background */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20premium%20health%20food%20products%20on%20clean%20surface%20gummies%20herbal%20bars%20and%20freeze%20dried%20packages%20arranged%20artfully%20warm%20cream%20and%20coral%20accents%20soft%20studio%20lighting%20minimalist%20product%20photography%20organic%20botanical%20elements%20no%20text%20clean%20composition&width=1920&height=600&seq=products-hero-kv-001&orientation=landscape')`
            }}
          />
          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-brand-cream/95 via-brand-cream/88 to-brand-cream/95" />

          <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto text-center">
            <span className="inline-block text-xs font-semibold tracking-wider text-brand-gray uppercase mb-4">
              {data.hero.subtitle}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-brand-charcoal mb-6 leading-tight">
              {data.hero.title}
            </h1>
            <p className="text-base md:text-lg text-brand-gray leading-relaxed">
              {data.hero.description}
            </p>
          </div>
        </section>

        {/* Track Tabs */}
        <section className="py-8 md:py-10 bg-white border-b border-brand-gray-pale/40 sticky top-16 md:top-20 z-30">
          <div className="w-full px-6 md:px-10 lg:px-16">
            <div className="flex flex-wrap justify-center gap-3 md:gap-4">
              {data.tracks.map((track, index) => {
                const colors = getTrackColor(index);
                return (
                  <button
                    key={track.name}
                    onClick={() => setActiveTrack(index)}
                    className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                      activeTrack === index
                        ? colors.active
                        : 'bg-brand-cream text-brand-gray hover:bg-brand-gray-pale/40'
                    }`}
                  >
                    <span className={`inline-block w-2 h-2 rounded-full mr-2 ${colors.dot}`}></span>
                    {track.name}
                  </button>
                );
              })}
            </div>
          </div>
        </section>

        {/* Active Track Content */}
        <section className="py-16 md:py-24 bg-brand-cream">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto">
            {/* Track Header */}
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-2xl md:text-3xl font-bold text-brand-charcoal mb-2">
                {currentTrack.name}
              </h2>
              <p className="text-lg font-serif italic text-brand-gray mb-4">
                {currentTrack.tagline}
              </p>
              <p className="text-sm md:text-base text-brand-gray max-w-2xl mx-auto">
                {currentTrack.description}
              </p>
            </div>

            {/* Features */}
            <div className="flex flex-wrap justify-center gap-3 mb-12">
              {currentTrack.features.map((feature) => (
                <span
                  key={feature}
                  className="px-4 py-2 bg-white rounded-full text-sm font-medium text-brand-gray border border-brand-gray-pale/30"
                >
                  {feature}
                </span>
              ))}
            </div>

            {/* Products Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" data-product-shop>
              {currentTrack.products.map((product, pIndex) => (
                <div key={product.name} className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300">
                  <div className="w-full h-48 md:h-52 overflow-hidden">
                    <img
                      src={productImages[activeTrack][pIndex]}
                      alt={product.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5 md:p-6">
                    <div className="flex items-center gap-2 mb-2">
                      <span className={`inline-block px-2.5 py-1 rounded-md text-xs font-medium text-white ${
                        activeTrack === 0 ? 'bg-brand-mint-dark' : activeTrack === 1 ? 'bg-brand-coral' : 'bg-brand-green'
                      }`}>
                        {product.tag}
                      </span>
                    </div>
                    <h3 className="text-base font-semibold text-brand-charcoal mb-3">
                      {product.name}
                    </h3>
                    <div className="mb-3">
                      <span className="text-xs text-brand-gray-light block mb-1">{t('misc.coreIngredients')}</span>
                      <div className="flex flex-wrap gap-1.5">
                        {product.ingredients.map((ing) => (
                          <span key={ing} className="px-2 py-0.5 bg-brand-cream text-xs text-brand-gray rounded">
                            {ing}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-brand-gray-light">
                        {t('misc.suitableFor')}{product.target}
                      </span>
                      <button className="px-4 py-2 bg-brand-charcoal text-white text-xs font-medium rounded-full hover:bg-brand-stone transition-colors whitespace-nowrap">
                        {t('misc.learnMore')}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}